import {
    ChallengesLevel
} from '@containers/activity-router/routes/learn/challenges/components/challenges-ui-filters/level-filter/level-filter.types';
import {
    DEFAULT_PLAYLIST_ID
} from '@containers/activity-router/routes/learn/challenges/components/challenges-ui-filters/playlist-filter/playlist-filter.types';
import {
    ChallengesComplexity,
    TransformCourse
} from '@services/gateways/combined-assign-gateway/combined-assign-gateway.types';

export const getChallengesPlaylistLevelAndDok = (course: TransformCourse) => {
    if (!course?.topics) {
        return {
            updatedLevelFilter: [],
            updatedDokFilter: []
        };
    }

    const dokSet = new Set<ChallengesComplexity>();
    const levelSet = new Set<ChallengesLevel>();

    course.topics.forEach((strand) => {
        strand.topics?.forEach((topic) => {
            topic.activities.forEach((activity) => {
                const { yearGroup } = activity.extraProperties;

                dokSet.add(activity.complexity as ChallengesComplexity);
                levelSet.add(yearGroup);
            });
        });
    });

    return {
        updatedLevelFilter: Array.from(levelSet),
        updatedDokFilter: Array.from(dokSet)
    };
};

export const isPlaylistsActive = (playlistFilterId: number) => playlistFilterId !== DEFAULT_PLAYLIST_ID;
